(function() {
  const faqsWrapper = document.querySelector('.article-template__faqs');

  if (!faqsWrapper) return;

  faqsWrapper.addEventListener('click', (e) => {
    if (e.target.classList.contains('article-template__faq-question') || e.target.closest('.article-template__faq-question')) {
      const faqWrapper = e.target.closest('.article-template__faq-wrapper');
      const faqAnswerWrapper = faqWrapper.querySelector('.article-template__faq-answer');

      if (!faqWrapper || !faqAnswerWrapper) return;

      faqWrapper.classList.toggle('open');

      if (faqWrapper.classList.contains('open')) {
        faqAnswerWrapper.style.height = `${faqAnswerWrapper.firstElementChild.offsetHeight}px`;
      } else {
        faqAnswerWrapper.style.height = '0';
      }
    }
  });

  faqsWrapper.querySelectorAll('.open').forEach((element) => {
    const faqAnswerWrapper = element.querySelector('.article-template__faq-answer');

    if (faqAnswerWrapper) {
      faqAnswerWrapper.style.height = `${faqAnswerWrapper.firstElementChild.offsetHeight}px`;
    }
  });
})();
